// В.2.h-rebalance: Генетик Лиза — активка «Призови копию любого юнита с поля
// с 1 ХП на свободную ячейку своей половины поля».
//
// Picker: ЛЮБОЙ юнит на поле — свой или вражеский. Если на поле нет юнитов
// (только Герои) → активка не срабатывает.
//
// Эффект:
//   1) summonUnitLivLife(state, target.id, ownerIdx, null) — свежий
//      инстанс шаблона на случайный свободный слот стороны Лизы.
//      onUnitSummoned-хуки срабатывают (Цепь, ауры, on-spawn-passives).
//   2) copy.current.hp = 1 (max_hp как в шаблоне).
//   3) Initiation Cooldown НЕ применяется (как любой summon).
//
// Если на стороне Лизы нет свободного слота → активка не срабатывает,
// флаг heroActiveUsed не ставится.

import { summonUnitLivLife } from './summon.js';
import { HERO_ID } from './liza.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

registerImplementedAbility(HERO_ID, 'active');

const LABEL = 'Лиза (active)';

export { HERO_ID };

// Кандидаты — все живые юниты на поле обоих сторон.
export function getLizaActiveTargets(state /*, playerIdx — не зависит */) {
  if (!state?.players) return [];
  const out = [];
  for (const p of state.players) {
    for (const u of p.unitsOnField()) {
      if (u.type === 'unit' && u.isAlive && u.isAlive()) out.push(u);
    }
  }
  return out;
}

export function lizaActiveAvailable(state, playerIdx) {
  const p = state?.players?.[playerIdx];
  if (!p || p.hero?.id !== HERO_ID) return false;
  if (p.heroActiveUsed) return false;
  if (p.hero.hp <= 0) return false;
  if (!p.hasFreeSlot()) return false;
  if (getLizaActiveTargets(state, playerIdx).length === 0) return false;
  return true;
}

export function lizaActive(state, playerIdx, targetInstanceId = null) {
  if (!lizaActiveAvailable(state, playerIdx)) {
    return { ok: false, reason: 'unavailable' };
  }
  const me = state.players[playerIdx];
  const candidates = getLizaActiveTargets(state, playerIdx);
  let target = null;
  if (targetInstanceId != null) {
    target = candidates.find(u => u.instanceId === targetInstanceId) || null;
    if (!target) return { ok: false, reason: 'invalid_target' };
  } else {
    // Бот-fallback: вражеский с max atk если есть, иначе свой с max atk.
    const enemyIdx = 1 - playerIdx;
    const enemies = candidates.filter(u => u.ownerId === enemyIdx);
    const own     = candidates.filter(u => u.ownerId === playerIdx);
    const pickHighestAtk = (arr) => {
      if (!arr.length) return null;
      let best = arr[0];
      for (const u of arr) if ((u.current?.atk ?? 0) > (best.current?.atk ?? 0)) best = u;
      const tied = arr.filter(u => (u.current?.atk ?? 0) === (best.current?.atk ?? 0));
      return tied.length === 1 ? tied[0] : tied[state.rng.int(tied.length)];
    };
    target = pickHighestAtk(enemies) || pickHighestAtk(own);
    if (!target) return { ok: false, reason: 'no_target' };
  }
  state.log?.add(
    `🧬 ${LABEL} [${me.name}]: копия ${target.name_ru} (исходник [${state.players[target.ownerId]?.name}]) с 1 ХП`
  );
  const r = summonUnitLivLife(state, target.id, playerIdx, null);
  if (!r.success || !r.card) {
    return { ok: false, reason: 'summon_failed' };
  }
  // current_hp = 1 (max_hp как в шаблоне).
  r.card.current.hp = 1;
  me.heroActiveUsed = true;
  return { ok: true, target, copy: r.card, line: r.line, slot: r.slot };
}
